var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('widget-list-row-header'),_vm._v(" "),_vm._l((_vm.widgets),function(widget,key){return _c('widgets-element',{key:key,attrs:{"mode":"list","widget":widget,"view-privilege":_vm.viewPrivilege,"manage-privilege":_vm.managePrivilege}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }